import React from 'react';
import { useSEOMetatags } from '@hooks/useSEOMetatags';
import { SITE_URLS } from '@constants';
import { MyAccountContainer } from '@components/organisms/MyAccountContainer';
import { Container } from '@components/atoms/Container';
import { Space } from '@components/atoms/Space';
import { Typography } from '@components/atoms/Typography';
import { useTranslation } from 'react-i18next';

export function DeleteAccountCompletedPage() {
    const { t } = useTranslation();

    const translations = {
        title: t('delete-account-completed-component.title'),
        text: t('delete-account-completed-component.text'),
    };

    useSEOMetatags({
        title: translations.title,
        description: translations.text,
        url: SITE_URLS.deleteAccountCompleted,
        index: false,
    });

    return (
        <MyAccountContainer title={translations.title}>
            <Container>
                <Space spaceBreakpoints={{ xs: { space: 30 } }} />
                <Typography color="muted">{translations.text}</Typography>
                <Space spaceBreakpoints={{ xs: { space: 30 } }} />
            </Container>
        </MyAccountContainer>
    );
}
